module.exports = __webpack_public_path__ + "static/zelt2-25067a28442e09b317f5feb53df49c5f.jpg";